export default __webpack_public_path__ + "static/media/chevrolet.2c67309a.svg";